'use client';

import { Error } from './components/Error';

export default Error;
